import script from "./dupliPopUp5.vue?vue&type=script&setup=true&lang=js"
export * from "./dupliPopUp5.vue?vue&type=script&setup=true&lang=js"

import "./dupliPopUp5.vue?vue&type=style&index=0&id=72accae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72accae9"]])

export default __exports__